<template lang="html">
  <el-dialog
    title="选择地址"
    :visible="dialogVisible"
    width="50%"
    @close="close"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="select-address-wrapper" v-if="dialogVisible">
      <el-input
        v-model="address"
        clearable
        placeholder="请输入内容"
        ref="baseInput"
        class="baseInput"
      >
      </el-input>
      <div id="map-select" class="d2-mt"></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addressArr: [],
      address: "",
      showMap: false,
      baseInput: {},
      userlocation: {}
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    /* eslint-disable no-undef */
    initMap() {
      this.map = new BMap.Map("map-select");
      this.map.addControl(
        new BMap.NavigationControl({ type: BMAP_NAVIGATION_CONTROL_SMALL })
      );
      this.map.centerAndZoom("杭州", 15);
      this.baseInput = new BMap.Autocomplete({
        input: this.$refs.baseInput.$el.children[0],
        location: this.map
      });
      this.resultConfirm();
    },
    setPlace() {
      // 清除地图上所有覆盖物
      this.map.clearOverlays();
      let local = new BMap.LocalSearch(this.map, {
        onSearchComplete: () => {
          this.userlocation = local.getResults().getPoi(0).point;
          this.map.centerAndZoom(this.userlocation, 18);
          let marker = new BMap.Marker(this.userlocation, {});
          // 添加标注
          this.map.addOverlay(marker);
          let slabel = new BMap.Label(this.address, {
            offset: new BMap.Size(15, -20)
          });
          marker.setLabel(slabel);
        }
      });
      local.search(this.address);
    },
    /* eslint-enable no-undef */
    resultConfirm() {
      // TODO: 有一个城市的code，暂时没获取到，后面确认下
      this.baseInput.addEventListener(
        "onconfirm",
        ({
          item: {
            value: { province, city, district, street, business }
          }
        }) => {
          if (!province && !city && !district) {
            return this.$myAlert("error", "请输入详细地址");
          }
          this.address = province + city + district + street + business;
          let reg = /省|区/gi;
          province = reg.test(city) ? city : "";
          this.addressObject = {
            province,
            city: province ? district : city,
            district: province ? "" : district,
            address: this.address
          };
          this.setPlace();
        }
      );
    },
    close() {
      this.$emit("update:dialogVisible", false);
    },
    sure() {
      if (!this.address) return this.$message.error("请先选择地址，再提交");
      let { lng, lat } = this.userlocation;
      let addressInfo = {
        address: this.addressObject,
        location: ""
      };
      if (this.addressObject && lng && lat) {
        addressInfo["location"] = lng + "," + lat;
        this.close();
        this.$emit("getAddress", addressInfo);
      } else {
        this.$message.error("请提交正确的地址");
      }
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.baseInput.focus();
          this.initMap();
        });
      }
    }
  },
  components: {}
};
</script>

<style lang="scss">
.baseInput {
  width: 100% !important;
  margin-bottom: 20px;
}
.tangram-suggestion-main {
  z-index: 9000 !important;
}
#map-select {
  height: 418px;
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/selectAddressDialog/index.vue